/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Trash = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M5.5 7V21.499H18.5V7H20V23H4V7H5.5ZM9.5 9V19H8V9H9.5ZM12.75 9V19H11.25V9H12.75ZM16 9V19H14.5V9H16ZM3 5.5V4H8V1H16V4H21V5.5H3ZM14.5 2.5H9.5V4H14.5V2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
